// The Onecta app sets window.unifiedApp.accessToken. To test in a browser,
// open /developer/access-token (see README.md, "Testing without the Onecta app").

let accessTokenInterval
export default async function(ctx) {
  if (!ctx.store.state.runningAccessTokenInterval) {
    const hasToRedirect = await checkAccessToken(ctx)
    if (hasToRedirect) {
      if (ctx.route.name !== 'index') {
        const language = ctx.$storage.getUniversal('language') || 'en'
        return ctx.app.router.push({
          name: 'launcher',
          query: { status: 'overview', preferred_language: language }
        })
      }
    }
  } else {
    clearInterval(accessTokenInterval)
    ctx.store.dispatch('setRunningAccessTokenInterval', false)
  }
  accessTokenInterval = setInterval(async () => {
    const hasToRedirect = await checkAccessToken(ctx)
    if (hasToRedirect) {
      if (ctx.route.name !== 'index') {
        const language = ctx.$storage.getUniversal('language') || 'en'
        return ctx.app.router.push({
          name: 'launcher',
          query: { status: 'overview', preferred_language: language }
        })
      }
    }
  }, 1000)
  ctx.store.dispatch('setRunningAccessTokenInterval', true)
}

async function checkAccessToken(ctx) {
  const oldAccessToken = await ctx.store.dispatch('getGigyaToken')
  const accessToken = window.unifiedApp?.accessToken
    ? window.unifiedApp.accessToken
    : null

  ctx.app.store.commit('access-token/setIsAccessToken', !!accessToken)
  await ctx.app.store.dispatch('access-token/setIsAccessToken', !!accessToken)

  if (
    (!oldAccessToken && accessToken) ||
    (oldAccessToken && accessToken && oldAccessToken !== accessToken)
  ) {
    // Save current user data before clearing storage
    // This will be used in setGigyaProfile to restore languageChoice if same user
    const currentProfile = await ctx.store.dispatch('getGigyaProfile')
    const languageChoice = await ctx.store.dispatch('getLanguageChoice')

    if (currentProfile?.email && languageChoice) {
      ctx.$storage.setUniversal('language_restore_data', {
        email: currentProfile.email,
        languageChoice
      })
    }

    await ctx.store.dispatch('clearStorage')
    ctx.store.commit('clearPageHistory')
    await ctx.store.dispatch('maintenance/clearStorage')
    await ctx.store.dispatch('account/clearStorage')
    await ctx.store.dispatch('installation/clearStorage')
    await ctx.store.dispatch('package/clearStorage')
    await ctx.store.dispatch('registration/clearRegistration')
    await ctx.store.dispatch('service-partner/clearStorage')
    await ctx.store.dispatch('energy/logout')

    ctx.store.commit('setHasNewAccessToken', true)
    ctx.store.commit('setGigyaReady', false)
    ctx.store.commit('setGigyaToken', accessToken)
    await ctx.store.dispatch('setGigyaToken', accessToken)

    return true // Redirect
  }
  return false
}
